export default __webpack_public_path__ + "static/media/frank-4.47c87a26.jpg";